import React from 'react';
import PropTypes from 'prop-types';
import AdvModal from '../AdvModal';
import { Wrapper } from './styles';
import ModalHeader from './Components/ModalHeader';
import ModalBody from './Components/ModalBody';
import ModalFooter from './Components/ModalFooter';
import { CloseButton } from '../OPL/CloseButton/CloseButton';
import { Box } from '../OPL/Box/Box';

const defaultStyles = {
  content: {
    background: '#fff',
    boxShadow: '0 0 9px 0 rgba(0, 0, 0, 0.5)',
    position: 'relative',
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '4px',
  },
  overlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    background: 'rgba(44, 42, 42, 0.6)',
    zIndex: '15000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const Modal = props => (
  <AdvModal
    isOpen={props.isOpen}
    onRequestClose={props.onRequestClose}
    shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
    portalClassName={props.className}
    overlayClassName={`${props.className}__overlay`}
    className={`${props.className}__content`}
    style={defaultStyles}
    htmlClass={props.htmlClass}
    bodyClass={props.bodyClass}
  >
    {props.showCloseModalCross && (
      <Box css={{ zIndex: 2, right: 0 }} position="absolute">
        <Box p="8">
          <CloseButton onClick={props.onRequestClose} />
        </Box>
      </Box>
    )}
    <Wrapper>{props.children}</Wrapper>
  </AdvModal>
);

Modal.setAppElement = element => AdvModal.setAppElement(element);

Modal.defaultProps = {
  onRequestClose: () => {},
  shouldCloseOnOverlayClick: false,
  showCloseModalCross: false,
  htmlClass: '',
  bodyClass: '',
  className: null,
  children: null,
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
  showCloseModalCross: PropTypes.bool,
  htmlClass: PropTypes.string,
  bodyClass: PropTypes.string,
};

export const SubComponents = {
  ModalHeader,
  ModalBody,
  ModalFooter,
};

export default Modal;
